<script setup lang="ts">
interface TableWrapperInterface {
    showFooter?: boolean
}

withDefaults(defineProps<TableWrapperInterface>(), {
    showFooter: false,
})
</script>

<template>
    <div class="kidzonet-table-wrapper">
        <div class="kidzonet-table-wrapper__content">
            <div class="kidzonet-table-wrapper__header">
                <slot name="header" />
            </div>
            <slot />
        </div>
        <div
            v-if="showFooter"
            class="kidzonet-table-wrapper__footer"
        >
            <slot name="footer" />
        </div>
    </div>
</template>

<style>
    .kidzonet-table-wrapper {
        display: flex;
        flex-direction: column;

        border-radius: 16px;

        background-color: var(--widget-background-color);
        box-shadow: 0px 4px 8px rgba(36, 36, 36, 0.02);

        &__header {
            padding: 1em 1em 0 1em;
            border-start-start-radius: 16px;
            border-start-end-radius: 16px;
        }

        &__content {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        }

        &__footer {
            padding: 16px;
            border-end-start-radius: 16px;
            border-end-end-radius: 16px;
            background-color: rgb(var(--v-theme-tableFooter));
        }
    }
</style>
